"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWrapper = void 0;
var react_1 = __importDefault(require("react"));
var i18n_1 = require("../../i18n");
var styles_1 = require("../../styles");
var Button_1 = require("../Button");
var Icon_1 = require("../Icon/Icon");
var react_2 = require("../../util/react");
exports.InputWrapper = react_1.default.forwardRef(function (props, ref) {
    var children = props.children, icon = props.icon, iconDisabled = props.iconDisabled, iconAriaLabel = props.iconAriaLabel, externalOnIconClick = props.onIconClick, clearVisible = props.clearVisible, onClear = props.onClear, className = props.className, iconPosition = props.iconPosition, externalIconProps = props.iconProps, iconRef = props.iconRef, rest = __rest(props, ["children", "icon", "iconDisabled", "iconAriaLabel", "onIconClick", "clearVisible", "onClear", "className", "iconPosition", "iconProps", "iconRef"]);
    var _a = externalIconProps !== null && externalIconProps !== void 0 ? externalIconProps : {}, iconPropsOnClick = _a.onClick, iconProps = __rest(_a, ["onClick"]);
    var onIconClick = iconPropsOnClick || externalOnIconClick ? react_2.composeHandlers(iconPropsOnClick, externalOnIconClick) : null;
    var internalIconPosition = iconPosition || (onIconClick ? 'right' : 'left');
    var _b = styles_1.useStyles(createStyles, {
        icon: icon,
        iconPosition: internalIconPosition,
        clearVisible: clearVisible,
        onIconClick: onIconClick,
    }), classes = _b.classes, css = _b.css;
    var locale = i18n_1.useLocale();
    var iconBoxClasses = css(classes.iconWrapper, internalIconPosition === 'left' && classes.iconLeft, internalIconPosition === 'right' && classes.iconRight);
    return (react_1.default.createElement("div", __assign({ ref: ref, className: css(classes.wrapper, className) }, rest),
        children,
        clearVisible && (react_1.default.createElement("span", { role: 'button', title: locale.input.clear, tabIndex: -1, onClick: onClear, className: classes.clearButton, "aria-label": iconAriaLabel },
            react_1.default.createElement(Icon_1.Icon, { size: 1.5, icon: 'timesDefault' }))),
        icon && (react_1.default.createElement("span", { className: iconBoxClasses }, onIconClick ? (react_1.default.createElement(Button_1.Button, __assign({ size: 'small', skin: 'ghost', tabIndex: -1, onClick: onIconClick, style: classes.icon, innerRef: iconRef }, iconProps, { disabled: iconDisabled, "aria-label": iconAriaLabel }),
            react_1.default.createElement(Icon_1.Icon, { icon: icon }))) : (react_1.default.createElement(Icon_1.Icon, { icon: icon, style: classes.icon, "aria-label": iconAriaLabel }))))));
});
exports.InputWrapper.defaultProps = {
    iconDisabled: false,
    clearVisible: false,
    onClear: function () { return null; },
};
var createStyles = function (theme, _a) {
    var icon = _a.icon, iconPosition = _a.iconPosition, clearVisible = _a.clearVisible, onIconClick = _a.onIconClick;
    var clickable = typeof icon !== 'string' || onIconClick;
    var paddingLeft = (icon && iconPosition === 'left' && clickable && '3rem') ||
        (icon && iconPosition === 'left' && '2.5rem') ||
        undefined;
    var paddingRight = (icon && iconPosition === 'right' && clearVisible && clickable && '4.5rem') ||
        (icon && iconPosition === 'right' && clearVisible && '4rem') ||
        (icon && iconPosition === 'right' && clickable && '3rem') ||
        (icon && iconPosition === 'right' && '2.5rem') ||
        (clearVisible && '2rem') ||
        undefined;
    return {
        wrapper: {
            position: 'relative',
            input: {
                paddingLeft: paddingLeft,
                paddingRight: paddingRight,
            },
        },
        clearButton: {
            position: 'absolute',
            right: icon && iconPosition === 'right' ? (clickable && '2.5rem') || '2rem' : 1,
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            height: '100%',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            outline: 0,
            color: theme.pallete.text.secondary,
            padding: '1px 6px',
            '&:hover': {
                color: theme.pallete.status.danger.main,
            },
        },
        iconWrapper: {
            position: 'absolute',
            backgroundColor: clickable ? theme.pallete.gray.c90 : 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0.25rem',
            width: '2.5rem',
            top: 1,
            bottom: 1,
        },
        iconLeft: {
            left: 1,
        },
        iconRight: {
            right: 1,
        },
        icon: {
            borderRadius: 'inherit',
            '&:focus': {
                boxShadow: 'none',
            },
        },
    };
};
//# sourceMappingURL=InputWrapper.js.map